import createReducer from 'utils/redux/createReducer'

const initialState = window.innerWidth

export default createReducer(initialState, {
	CHANGE_TIME: (currentState, action) => action.data
})



// WEBPACK FOOTER //
// ./src/reducers/time.js